import React from "react";
import bulmaAccordion from "bulma-extensions/bulma-accordion/dist/js/bulma-accordion.min.js";
import "bulma-extensions/bulma-accordion/dist/css/bulma-accordion.min.css";
import axios from "axios";
import CheckBox from "./CheckBox";
import Accordion from "./Accordion";

export default class FilterPannel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkBox: [],
    };
  }

  componentDidMount() {
    // eslint-disable-next-line
    var accordions = bulmaAccordion.attach();
    axios
      .get(`${process.env.PUBLIC_URL}/data.json`)
      .then((res) => {
        this.setState({ checkBox: res.data.checkboxes });
      })
      .catch((err) => console.log(err.message));
  }

  handle = (e) => {
    console.log(e.target.value);
  };

  handleCheckBoxLanguages = (e) => {
    console.log(e.target.checked);
    let checkBoxDataLanguages = this.state.checkBox.languages;
    checkBoxDataLanguages.forEach((elem) => {
      if (elem.value === e.target.value) {
        elem.isChecked = e.target.checked;
      }
    });

    //const { languages } = this.state.checkBox
    this.setState({ languages: checkBoxDataLanguages });

    let languagesFiltered = checkBoxDataLanguages.filter((elem) => {
      return elem.isChecked === true;
    });

    this.setState({ languagesFilter: languagesFiltered });

    this.props.filterfun(languagesFiltered);
  };

  handleCheckBox = (e) => {
    const { languages, productType, technologies } = this.state.checkBox;

    let checkBoxDataLanguages = languages;
    checkBoxDataLanguages.forEach((elem) => {
      if (elem.value === e.target.value) {
        elem.isChecked = e.target.checked;
      }
    });

    let checkBoxDataTechnologies = technologies;
    checkBoxDataTechnologies.forEach((elem) => {
      if (elem.value === e.target.value) {
        elem.isChecked = e.target.checked;
      }
    });

    let checkBoxDataProductType = productType;
    checkBoxDataProductType.forEach((elem) => {
      if (elem.value === e.target.value) {
        elem.isChecked = e.target.checked;
      }
    });

    this.setState({ languages: checkBoxDataLanguages });
    this.setState({ technologies: checkBoxDataTechnologies });
    this.setState({ productType: checkBoxDataProductType });

    let languagesFiltered = checkBoxDataLanguages.filter((elem) => {
      return elem.isChecked === true;
    });
    let technologiesFiltered = checkBoxDataTechnologies.filter((elem) => {
      return elem.isChecked === true;
    });
    let productTypeFiltered = checkBoxDataProductType.filter((elem) => {
      return elem.isChecked === true;
    });

    this.props.filterfun([
      ...languagesFiltered,
      ...technologiesFiltered,
      ...productTypeFiltered,
    ]);
  };

  render() {
    const { languages, productType, technologies } = this.state.checkBox;

    return (
      <React.Fragment>
        <div>
          <Accordion title="Languages">
            <div>
              {languages &&
                languages.map((elem) => {
                  return (
                    <CheckBox
                      handleCheckBox={this.handleCheckBox}
                      key={`${elem.id}+${elem.value}`}
                      {...elem}
                    />
                  );
                })}
            </div>
          </Accordion>
          <Accordion title="Technologies">
            <div>
              {technologies &&
                technologies.map((elem) => {
                  return (
                    <CheckBox
                      key={`${elem.id}+${elem.value}`}
                      handleCheckBox={this.handleCheckBox}
                      {...elem}
                    />
                  );
                })}
            </div>
          </Accordion>
          <Accordion title="Product Type">
            <div>
              {productType &&
                productType.map((elem) => {
                  return (
                    <CheckBox
                      key={`${elem.id}+${elem.value}`}
                      handleCheckBox={this.handleCheckBox}
                      {...elem}
                    />
                  );
                })}
            </div>
          </Accordion>
          {/* <section className="accordions">
                        <article className="accordion is-active">
                            <div className="accordion-header accordian-style">
                                <p> <b> Languages </b></p>

                                <button className="toggle" aria-label="toggle"></button>
                            </div>
                            <div className="accordion-body accordian-style">
                                <div className="accordion-content">
                                    {languages && languages.map((elem) => {
                                        return <CheckBox handleCheckBox={this.handleCheckBox} key={`${elem.id}+${elem.value}`} {...elem} />
                                    })}
                                </div>
                            </div>
                        </article>
                        <article className="accordion">
                            <div className="accordion-header accordian-style">
                                <p> <b> Technologies </b></p>
                                <button className="toggle" aria-label="toggle"></button>
                            </div>
                            <div className="accordion-body accordian-style">
                                <div className="accordion-content">
                                    {technologies && technologies.map((elem) => {
                                        return <CheckBox key={`${elem.id}+${elem.value}`} handleCheckBox={this.handleCheckBox}  {...elem} />
                                    })}

                                </div>
                            </div>
                        </article>
                        <article className="accordion">
                            <div className="accordion-header accordian-style">
                                <p> <b> Product Type </b></p>
                                <button className="toggle" aria-label="toggle"></button>
                            </div>
                            <div className="accordion-body accordian-style">
                                <div className="accordion-content">
                                    {productType && productType.map((elem) => {
                                        return <CheckBox key={`${elem.id}+${elem.value}`} handleCheckBox={this.handleCheckBox}  {...elem} />
                                    })}
                                </div>
                            </div>
                        </article>
                    </section> */}
        </div>
      </React.Fragment>
    );
  }
}
